export const PageRoute = {
    LOGIN: "/login",
    FORGOT_PASSWORD: "/forgot-password",
    FORGOT_PASSWORD_SENT: "/forgot-password/sent",
    RESET_PASSWORD: "/reset-password",

    HOME: "/",
    PROPERTIES: "/properties",
    CLIENTS: "/clients",
    OWNERS: "/owners",
    FEATURES: "/features",
    POPULAR_PLACES: "/popular-places",
    BLOG: "/blogs",
    HOMEPAGE_IMAGE: "/homepage-image",
    MEMBERS: "/members",
    ACCOUNT: "/account"
}